@if (modalToolContainerIsDisplayed) {
  <div class="wm-m-modaltoolcontainer-wrapper">
    <div class="wm-tooloverlay-backdrop" (click)="closeToolContainer()"></div>
    <div class="wm-m-modaltoolcontainer" [ngClass]="{'no-height': currentToolConfig()?.noFixedHeight, 'wide-container': currentToolConfig()?.wideContainer}">
      @if (!currentToolConfig()?.hideHeader) {
        <div class="modaltoolcontainer-header">
          <div class="modaltoolcontainer-label">{{currentToolConfig()?.toolName}}</div>
          @if (!currentToolConfig()?.notDismissible && currentToolChain?.length === 1) {
            <div class="modaltoolcontainer-close-button" data-testing-id="modaltoolcontainer-close-button" (click)="closeToolContainer()"><fa-icon icon="times"></fa-icon></div>
          }
          @if (currentToolChain?.length > 1) {
            <div class="modaltoolcontainer-close-back" data-testing-id="modaltoolcontainer-close-back" (click)="closeCurrentTool()"><fa-icon icon="chevron-left"></fa-icon> <span class="label">Back to {{previousToolConfig()?.toolName}}</span></div>
          }
        </div>
      }
      <div class="wm-m-modaltoolcontainer-views">
        <div id="wm-modaltoolcontainer-view0" class="wm-modaltoolcontainer-view" [ngClass]="{'scrollable': shouldScroll(0), 'hidden': currentIndex() !== 0}"></div>
        <div id="wm-modaltoolcontainer-view1" class="wm-modaltoolcontainer-view" [ngClass]="{'scrollable': shouldScroll(1),'hidden': currentIndex() !== 1}"></div>
        <div id="wm-modaltoolcontainer-view2" [hidden]="currentIndex() !== 2" class="wm-modaltoolcontainer-view" [ngClass]="{'scrollable': shouldScroll(2)}"></div>
        <div id="wm-modaltoolcontainer-view3" [hidden]="currentIndex() !== 3" class="wm-modaltoolcontainer-view" [ngClass]="{'scrollable': shouldScroll(3)}"></div>
        <div id="wm-modaltoolcontainer-view4" [hidden]="currentIndex() !== 4" class="wm-modaltoolcontainer-view" [ngClass]="{'scrollable': shouldScroll(4)}"></div>
        <!-- hope there won't be more nesting necessary -->
      </div>
    </div>
  </div>
}
